import { BinderDeliverable } from '@/models/binder-deliverable';
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BinderDeliverablesService {
  delData = signal<BinderDeliverable[]>([]);
  private serverCopy: BinderDeliverable[] = []; // Holds the last known server state
  private delCopy: BinderDeliverable[] = []; // This will now act as our local state
  private delRemove: BinderDeliverable[] = []; // Keep track of items to remove
  saved = signal<boolean>(true);

  private BASE_URL = environment.landmark_API_URL + '/binderdeliverables';

  constructor(
    private http: HttpClient
  ) { }

  //---------------------------------Deliverable Data---------------------------------

  updateLocalData(newData: BinderDeliverable[], saved: boolean) {
    // console.log('updating local data:', newData, saved);
    this.delCopy = [...newData];
    this.delData.set(this.delCopy);
    this.saved.set(saved);
  }

  updateServerData(newData: BinderDeliverable[]) {
    this.serverCopy = [...newData];
    this.updateLocalData(newData, true);
  }

  resetData() {
    this.updateLocalData(this.serverCopy, true);
    this.delRemove = [];
  }

  addLocalDeliverable(deliverable: BinderDeliverable) {
    this.updateLocalData([...this.delCopy, deliverable], false);
  }

  updateLocalDeliverableQuantity(DelID: number, newQuantity: number) {
    const index = this.delCopy.findIndex(d => d.DelID === DelID);
    if (index !== -1) {
      const updatedDeliverable = { ...this.delCopy[index], Quantity: newQuantity };
      this.delCopy[index] = updatedDeliverable;
      this.delData.set([...this.delCopy]);
      this.saved.set(false);
    }
  }

  removeLocalDeliverable(DelID: number) {
    const index = this.delCopy.findIndex(d => d.DelID === DelID);
    if (index !== -1) {
      const deliverable = this.delCopy[index];
      if (deliverable.BDelID) {
        this.delRemove.push(deliverable);
      }
      this.delCopy.splice(index, 1);
      this.delData.set([...this.delCopy]);
      this.saved.set(false);
    }
  }

  saveChanges(binderId: number): Observable<BinderDeliverable[]> {
    return this.saveBatchChanges(binderId, this.delRemove, this.delCopy).pipe(
      tap(updatedDeliverables => {
        console.log('updated deliverables:', updatedDeliverables);
        this.updateServerData(updatedDeliverables);
        this.delRemove = [];
        this.saved.set(true);
      }),
      catchError(error => {
        console.error('Error saving deliverables:', error);
        this.saved.set(false);
        return throwError(() => new Error('Failed to save deliverables. Please try again.'));
      })
    );
  }
  
  loadBinderDeliverables(binderID: number) {
    this.getBinderDeliverables(binderID).subscribe(
      (data: BinderDeliverable[]) => {
        this.updateServerData(data);
      }
    )
  }

  getBinderDeliverables(binderID: number): Observable<BinderDeliverable[]> {
    return this.http.get<BinderDeliverable[]>(`${this.BASE_URL}/binder/${binderID}/deliverables`);
  }

  saveBatchChanges(binderId: number, removeList: BinderDeliverable[], upsertList: BinderDeliverable[]): Observable<BinderDeliverable[]> {
    console.log('binderId:',binderId)
    console.log('saving Batch:', removeList, upsertList)
    const body = {
      removeList: removeList,
      upsertList: upsertList
    }
    return this.http.post<BinderDeliverable[]>(`${this.BASE_URL}/batch/${binderId}`, body);
  }
}